import { RouteStep } from '~/routes/calculations/types';

const step: RouteStep = {
  route: '/homeowners-insurance/quotes/bundle-location',
  isAccessible: () => true,
  breadcrumbStep: 'property',
};

export default step;
